function hex(c) {
  var s = "0123456789abcdef"
  var i = parseInt(c)
  if (i == 0 || isNaN(c)) return "00"
  i = Math.round(Math.min(Math.max(0, i), 255))
  return s.charAt((i - (i % 16)) / 16) + s.charAt(i % 16)
}

/* Convert an RGB triplet to a hex string */
function convertToHex(rgb) {
  return hex(rgb[0]) + hex(rgb[1]) + hex(rgb[2])
}

/* Remove '#' in color hex string */
function trim(s) {
  return s.charAt(0) == "#" ? s.substring(1, 7) : s
}

/* Convert a hex string to an RGB triplet */
function convertToRGB(hex) {
  var color = []
  color[0] = parseInt(trim(hex).substring(0, 2), 16)
  color[1] = parseInt(trim(hex).substring(2, 4), 16)
  color[2] = parseInt(trim(hex).substring(4, 6), 16)
  return color
}

export function generateColor(colorStart, colorEnd, colorCount) {
  // The beginning of your gradient
  var start = convertToRGB(colorStart)

  // The end of your gradient
  var end = convertToRGB(colorEnd)

  // The number of colors to compute
  var len = colorCount

  //Alpha blending amount
  var alpha = 0.0

  var saida = []

  for (var i = 0; i < len; i++) {
    var c = []
    alpha += 1.0 / len

    c[0] = start[0] * alpha + (1 - alpha) * end[0]
    c[1] = start[1] * alpha + (1 - alpha) * end[1]
    c[2] = start[2] * alpha + (1 - alpha) * end[2]

    saida.push("#" + convertToHex(c))
  }

  return saida
}

export function defaultColors() {
  let arr = []
  arr.push("#f50187")
  arr.push("#7bfa04")
  arr.push("#0572f8")
  arr.push("#f9ad62")
  arr.push("#66605f")
  arr.push("#4ef5af")
  arr.push("#7e09f9")
  arr.push("#fe5df4")
  arr.push("#f44103")
  arr.push("#07a50a")
  arr.push("#88a9ff")
  arr.push("#1a06a7")
  arr.push("#8c0214")
  arr.push("#effb08")
  arr.push("#bbe1ae")
  arr.push("#04ab85")
  arr.push("#918a03")
  arr.push("#aa4eba")
  arr.push("#03e1fb")
  arr.push("#1ef747")
  arr.push("#95c457")
  arr.push("#054950")
  arr.push("#7c0282")
  arr.push("#e703e6")
  arr.push("#4b4901")
  arr.push("#537aba")
  arr.push("#c8575f")
  arr.push("#1a17fe")
  arr.push("#ee9c03")
  arr.push("#3b063f")
  arr.push("#dbaaec")
  arr.push("#83fcfc")
  arr.push("#53a631")
  arr.push("#f8fb7c")
  arr.push("#e87ba0")
  arr.push("#0d51ac")
  arr.push("#9d8f91")
  arr.push("#04fb95")
  arr.push("#6351fc")
  arr.push("#d90339")
  arr.push("#1aafca")
  arr.push("#02f500")
  arr.push("#79baba")
  arr.push("#532ac0")
  arr.push("#b7cd14")
  arr.push("#49c177")
  arr.push("#ff7237")
  arr.push("#a54820")
  arr.push("#86ff75")
  arr.push("#a606c0")
  arr.push("#287c68")
  arr.push("#bb34fe")
  arr.push("#fcc1b5")
  arr.push("#064e06")
  arr.push("#bcfc46")
  arr.push("#4dd3ef")
  arr.push("#fb3bb0")
  arr.push("#3c3378")
  arr.push("#3d98f6")
  arr.push("#b7923c")
  arr.push("#040162")
  arr.push("#3fe20c")
  arr.push("#b61a72")
  arr.push("#ac75f5")
  arr.push("#12b848")
  arr.push("#c5e9f7")
  arr.push("#86294d")
  arr.push("#945583")
  arr.push("#64e13e")
  arr.push("#fb0001")
  arr.push("#4a0a02")
  arr.push("#e8d032")
  arr.push("#287824")
  arr.push("#ccd373")
  arr.push("#c7760c")
  arr.push("#fd4e73")
  arr.push("#ad9fcd")
  arr.push("#1cfdc9")
  arr.push("#757c30")
  arr.push("#f73241")
  arr.push("#0327cd")
  arr.push("#729b65")
  arr.push("#49f871")
  arr.push("#f9fbb4")
  arr.push("#87ecab")
  arr.push("#754fb5")
  arr.push("#314ae5")
  arr.push("#414a39")
  arr.push("#dd62cc")
  arr.push("#7cbc0e")
  arr.push("#733019")
  arr.push("#021933")
  arr.push("#c2200b")
  arr.push("#4a02f6")
  arr.push("#558901")
  arr.push("#d0b09a")
  arr.push("#042784")
  arr.push("#7a7fe4")
  arr.push("#359899")
  arr.push("#6d7a8d")
  //pre istotu este raz
  arr.push("#f50187")
  arr.push("#7bfa04")
  arr.push("#0572f8")
  arr.push("#f9ad62")
  arr.push("#66605f")
  arr.push("#4ef5af")
  arr.push("#7e09f9")
  arr.push("#fe5df4")
  arr.push("#f44103")
  arr.push("#07a50a")
  arr.push("#88a9ff")
  arr.push("#1a06a7")
  arr.push("#8c0214")
  arr.push("#effb08")
  arr.push("#bbe1ae")
  arr.push("#04ab85")
  arr.push("#918a03")
  arr.push("#aa4eba")
  arr.push("#03e1fb")
  arr.push("#1ef747")
  arr.push("#95c457")
  arr.push("#054950")
  arr.push("#7c0282")
  arr.push("#e703e6")
  arr.push("#4b4901")
  arr.push("#537aba")
  arr.push("#c8575f")
  arr.push("#1a17fe")
  arr.push("#ee9c03")
  arr.push("#3b063f")
  arr.push("#dbaaec")
  arr.push("#83fcfc")
  arr.push("#53a631")
  arr.push("#f8fb7c")
  arr.push("#e87ba0")
  arr.push("#0d51ac")
  arr.push("#9d8f91")
  arr.push("#04fb95")
  arr.push("#6351fc")
  arr.push("#d90339")
  arr.push("#1aafca")
  arr.push("#02f500")
  arr.push("#79baba")
  arr.push("#532ac0")
  arr.push("#b7cd14")
  arr.push("#49c177")
  arr.push("#ff7237")
  arr.push("#a54820")
  arr.push("#86ff75")
  arr.push("#a606c0")
  arr.push("#287c68")
  arr.push("#bb34fe")
  arr.push("#fcc1b5")
  arr.push("#064e06")
  arr.push("#bcfc46")
  arr.push("#4dd3ef")
  arr.push("#fb3bb0")
  arr.push("#3c3378")
  arr.push("#3d98f6")
  arr.push("#b7923c")
  arr.push("#040162")
  arr.push("#3fe20c")
  arr.push("#b61a72")
  arr.push("#ac75f5")
  arr.push("#12b848")
  arr.push("#c5e9f7")
  arr.push("#86294d")
  arr.push("#945583")
  arr.push("#64e13e")
  arr.push("#fb0001")
  arr.push("#4a0a02")
  arr.push("#e8d032")
  arr.push("#287824")
  arr.push("#ccd373")
  arr.push("#c7760c")
  arr.push("#fd4e73")
  arr.push("#ad9fcd")
  arr.push("#1cfdc9")
  arr.push("#757c30")
  arr.push("#f73241")
  arr.push("#0327cd")
  arr.push("#729b65")
  arr.push("#49f871")
  arr.push("#f9fbb4")
  arr.push("#87ecab")
  arr.push("#754fb5")
  arr.push("#314ae5")
  arr.push("#414a39")
  arr.push("#dd62cc")
  arr.push("#7cbc0e")
  arr.push("#733019")
  arr.push("#021933")
  arr.push("#c2200b")
  arr.push("#4a02f6")
  arr.push("#558901")
  arr.push("#d0b09a")
  arr.push("#042784")
  arr.push("#7a7fe4")
  arr.push("#359899")
  arr.push("#6d7a8d")
  //pre istotu este raz druhykrat
  arr.push("#f50187")
  arr.push("#7bfa04")
  arr.push("#0572f8")
  arr.push("#f9ad62")
  arr.push("#66605f")
  arr.push("#4ef5af")
  arr.push("#7e09f9")
  arr.push("#fe5df4")
  arr.push("#f44103")
  arr.push("#07a50a")
  arr.push("#88a9ff")
  arr.push("#1a06a7")
  arr.push("#8c0214")
  arr.push("#effb08")
  arr.push("#bbe1ae")
  arr.push("#04ab85")
  arr.push("#918a03")
  arr.push("#aa4eba")
  arr.push("#03e1fb")
  arr.push("#1ef747")
  arr.push("#95c457")
  arr.push("#054950")
  arr.push("#7c0282")
  arr.push("#e703e6")
  arr.push("#4b4901")
  arr.push("#537aba")
  arr.push("#c8575f")
  arr.push("#1a17fe")
  arr.push("#ee9c03")
  arr.push("#3b063f")
  arr.push("#dbaaec")
  arr.push("#83fcfc")
  arr.push("#53a631")
  arr.push("#f8fb7c")
  arr.push("#e87ba0")
  arr.push("#0d51ac")
  arr.push("#9d8f91")
  arr.push("#04fb95")
  arr.push("#6351fc")
  arr.push("#d90339")
  arr.push("#1aafca")
  arr.push("#02f500")
  arr.push("#79baba")
  arr.push("#532ac0")
  arr.push("#b7cd14")
  arr.push("#49c177")
  arr.push("#ff7237")
  arr.push("#a54820")
  arr.push("#86ff75")
  arr.push("#a606c0")
  arr.push("#287c68")
  arr.push("#bb34fe")
  arr.push("#fcc1b5")
  arr.push("#064e06")
  arr.push("#bcfc46")
  arr.push("#4dd3ef")
  arr.push("#fb3bb0")
  arr.push("#3c3378")
  arr.push("#3d98f6")
  arr.push("#b7923c")
  arr.push("#040162")
  arr.push("#3fe20c")
  arr.push("#b61a72")
  arr.push("#ac75f5")
  arr.push("#12b848")
  arr.push("#c5e9f7")
  arr.push("#86294d")
  arr.push("#945583")
  arr.push("#64e13e")
  arr.push("#fb0001")
  arr.push("#4a0a02")
  arr.push("#e8d032")
  arr.push("#287824")
  arr.push("#ccd373")
  arr.push("#c7760c")
  arr.push("#fd4e73")
  arr.push("#ad9fcd")
  arr.push("#1cfdc9")
  arr.push("#757c30")
  arr.push("#f73241")
  arr.push("#0327cd")
  arr.push("#729b65")
  arr.push("#49f871")
  arr.push("#f9fbb4")
  arr.push("#87ecab")
  arr.push("#754fb5")
  arr.push("#314ae5")
  arr.push("#414a39")
  arr.push("#dd62cc")
  arr.push("#7cbc0e")
  arr.push("#733019")
  arr.push("#021933")
  arr.push("#c2200b")
  arr.push("#4a02f6")
  arr.push("#558901")
  arr.push("#d0b09a")
  arr.push("#042784")
  arr.push("#7a7fe4")
  arr.push("#359899")
  arr.push("#6d7a8d")
  return arr
}

